module.exports = __webpack_public_path__ + "static/media/ESProjectsLogo.ddda53fb.jpg";